<template>
  <div>
    <div class='ctitle'>
    <h2>知识点列表</h2>
    </div>
    <div>
      <el-button @click='addKnowledge'>新增知识点1</el-button>
    </div>
    <div ref="searchDiv">
      <el-form ref="form" :model="form" :inline="true" style="text-align: left;padding-top: 20px;">
        <el-form-item label="关键词" label-width="60px">
          <el-input v-model="form.keywords" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-col :span="13">
            <el-button type="primary" @click="searchKnowledge">搜索</el-button>
          </el-col>
          <el-col :span="8">
            <el-button @click="searchKnowledgeAll">全部</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
    <knowledge-table :tableData="knowledgeList" ></knowledge-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import knowledgeTable from '@/components/knowledgeTable/knowledgeTable'
  import knowledgeDlg from '@/components/knowledgeDlg'

  export default {
    data () {
      return {
        form: {
          keywords: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'knowledgeList'
      ])
    },
    created () {
      this.$store.dispatch('actions_getKnowledgeList', this.form.keywords)
    },
    components: {
      knowledgeTable
    },
    methods: {
      searchKnowledge () {
        this.$store.dispatch('actions_getKnowledgeList', this.form.keywords)
      },
      searchKnowledgeAll () {
        this.form = {
          keywords: ''
        }
        this.searchKnowledge()
      },

      addKnowledge () {
        knowledgeDlg({
          isEditData: false
        })
      }
    }
  }
</script>

<style  scoped>
  .ctitle{
    height: 56px;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// knowledgeList.vue?3d6000f6